module.exports = __webpack_public_path__ + "static/media/guardian-network-group-m-en.17d51f58.webp";